import type { FaireProductEntity } from "../../entity_types/product";

export const p_2me5bgd4jg: FaireProductEntity = {
  token: "p_2me5bgd4jg",
  type: "product",
  name: "BRAIN FOODS Gluten Free Vegan Wafers (Vanilla)",
  brandToken: "b_46hn96hpk5",
  brandName: "Wilton Mettler LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a767595d088d1d95a165c4a1f148064358653e2505fda6f17cb929cb6e8ecdb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/095ddfacf71ea54eda8c16951bae70a337678ba56d7a23f0d28569f9555a9801.jpeg",
    "https://cdn.faire.com/fastly/f81d4152f9a17652219c17a90befc3078fc69295b623866fdeaacaef21cb1ada.jpeg",
    "https://cdn.faire.com/fastly/41b02acc8b3727300982e79af27e2b634dd977d57dbd739f547f368f9843c3e2.jpeg",
    "https://cdn.faire.com/fastly/dfd63decaee8f02bdef94dcf5c0f7eba5ab214f916e1092371532426f0206061.jpeg",
    "https://cdn.faire.com/fastly/7e661b547f2315f9867ae35a77066c6c59eaffdfdda7835a5fb81279e370acfb.jpeg",
    "https://cdn.faire.com/fastly/aa7bc39ab937143925551f4ff49465313accbf4f0e921f77485a37bcea45d1a3.jpeg",
    "https://cdn.faire.com/fastly/5d667dbb56dd0b672b43a2cfbe9348e9070e0a0755e0e2e884f6e5f51f7b8e03.jpeg",
    "https://cdn.faire.com/fastly/c4172ec601adf8a16a085e7c77843bc7c41e754ea3d3c6d35d88140c8ba1d17b.jpeg",
  ],
  priceDollars: 1.52,
  description:
    "Our vanilla wafer is GLUTEN-FREE, VEGAN, and has NO ADDED SUGAR. It's an ideal snack for coffee or tea breaks for health-conscious people. It’s truly unique to find a gluten-free wafer that not only caters to dietary restrictions but also maintains the crisp, satisfying texture and delicious flavor of traditional wafers. Containing less than a gram of naturally occurring sugar, Brain Foods Vanilla Wafers are made with 95% LESS SUGAR than other products in the category, ensuring a super-low glycemic impact. This means you can enjoy a satisfying snack without the dreaded afternoon crash, keeping your energy steady throughout the day! Each wafer has only 118 CALORIES per bar. Containing no palm oil and high in fiber (6.8 grams per wafer!), one bar provides 24% OF THE DAILY FIBER NEEDED to support digestion and gut health. Finally, a guilt-free, healthy, low-calorie snacking alternative for the body and mind!\n\n",
  tags: [],
  msrpDollars: 3.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:15.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
